// Returns the merged style for the given breakpoint.
// Desktop = el.style (base). Tablet/mobile = el.style merged with el.responsiveStyles[bp].
export function getEffectiveStyle(el, bp) {
  if (!bp || bp === 'desktop') return el.style || {};
  return { ...(el.style || {}), ...(el.responsiveStyles?.[bp] || {}) };
}

// Stub — uid is only called during drag/drop which never happens in preview
export function uid() {
  return Math.random().toString(36).slice(2, 9);
}

// Stub — applyDragPreview is only called on drag start, never in preview
export function applyDragPreview() {}